import { ReactNode } from 'react';
import { useChat, UseChatOptions } from './hooks/useChat';
import { ChatContext, ChatQueryContext } from './ChatContext';

interface ChatProviderProps {
  children: ReactNode;
  options?: UseChatOptions;
}

export const ChatProvider = ({ children, options }: ChatProviderProps) => {
  const { chatApi, chatQueryValue } = useChat(options);

  return (
    <ChatContext.Provider value={chatApi}>
      <ChatQueryContext.Provider value={chatQueryValue}>{children}</ChatQueryContext.Provider>
    </ChatContext.Provider>
  );
};
